<template>
  <div class="fixed footer">
    <div class="order-page bg-gray" v-if="curPage=='order-page'">
      <div class="flex flex-center bg">
        <div @click="showShoppingCart" class=" flex flex-center shopping-cart flex1 padd10px">
          <van-icon name="shopping-cart" :class="'icart'" size="22px">
            <div v-if="cart_qty" class="cart-info">{{cart_qty}}</div>
          </van-icon>
          <div class="subtotal">RM {{cart_subtotal || 0}}</div>
        </div>
        <div class="flex flex-center justify-between">
          <div class="lrBtn12 bg-red isCallwiter" @click="addOrder">Place Order</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { indexPage, validateBusinessAndHoliday} from '@/api/api'
export default {
  props: {
    pageName: {
      type: String,
      default: 'order-page'
    },
    pageData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      curPage: '',
      pageType: '',
      indexPage: {},
      store: {},
      isDine: false
    }
  },
  computed: {
    ...mapGetters([
      'cart_qty', 'cart_subtotal', 'store_info'
    ])
  },
  created () {
    this.curPage = this.pageName
  },
  methods: {
    ...mapActions({ resetShowCart: 'shoppping_cart/showShoppingCart' }),
    showShoppingCart () {
      // this.$emit("evtShowShoppingCart", true)
      this.resetShowCart(true)
    },
    addOrder () {
      // this.$router.push('/cart')
      // const url = { path: 'cart', query: { plan: 'private' }}
      // const url = { name: 'cart', params: { userId: 123 }}
      //  this.$router.push(url)
      const getRouteQuery = () => {
      let tempParams = this.$route.query
      if (tempParams.h5api == undefined) {
        tempParams["h5api"] = 'on'
      }
      tempParams["do"] = 'validateBusinessAndHoliday' 
      return tempParams
      }
      const updateOption = () => {
      const queryParams = Object.assign(getRouteQuery(), {storeid: this.store_info.id});
      console.log('queryParams', queryParams)
      validateBusinessAndHoliday("/app/index.php", queryParams)
              .then(res => {
                this.indexPage = res.data
                this.store = this.indexPage.store
                this.isDine = this.indexPage.isDineIn
                console.log('is Dine In ', this.isDine)
                console.log('res received', res.data)

                const table_type = this.store_info.table_type
                console.log('The store is rest >>> ',this.store.is_rest)
                if (this.store.is_24_hours_operation == 0 && this.store.is_rest == 0 || this.store.is_show != 1) {
                this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
                } else if (this.isDine && this.store.is_rest == 0 || this.store.is_show != 1){
                  this.$toast("Merchant is not operating, please try again later!")
                } else {
                    if (table_type && this.store_info[table_type] == 0) {
                        this.$toast(this.store_info.table_type_error)
                    } else{
                        this.$emit("evtCompleteOrder");
                    }
                }
              })
              .catch(error => {
                // console.log('添加到购物车.error', error);
              });
      };
      updateOption();
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.footer {
  z-index: 1000;
  left: 0;
  right: 0;
  bottom: 0;
  .isCallwiter {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .order-page {
    .shopping-cart {
      flex-basis: 125px;
      .icart {
        background-color: #272727b8;
        border-radius: 50%;
        padding: 8px;
        position: absolute;
        top: -10px;
        color: white;
      }
      .cart-info {
        position: absolute;
        top: 5px;
        right: 5px;
        box-sizing: border-box;
        min-width: 16px;
        padding: 0 3px;
        color: #fff;
        font-weight: 500;
        font-size: 12px;
        font-family: PingFang SC, Helvetica Neue, Arial, sans-serif;
        line-height: 14px;
        text-align: center;
        background-color: #ee0a24;
        border: 1px solid #fff;
        border-radius: 16px;
        -webkit-transform: translate(50%, -50%);
        transform: translate(50%, -50%);
        -webkit-transform-origin: 100%;
        transform-origin: 100%;
      }
      .subtotal {
        margin: 0 5px 0 45px;
      }
    }
    .lrBtn12 {
      padding: 12px 3px;
    }
  }
}
</style>
